import { Fragment } from "react";
import Header from "./components/Header/Header";

import "./App.css";
import Main from "./components/Main/Main";
import DataContextProvider from "./store/DataContextProvider";
import Footer from "./components/Footer/Footer";

function App() {
  return (
    <>
      <DataContextProvider>
        <Header />
        <Main />
      </DataContextProvider>
      <Footer />
    </>
  );
}

export default App;
